// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V9cnW","high":"styles_high__3ht3S","medium":"styles_medium__ymCWv","low":"styles_low__3L6NH","valueIcon":"styles_valueIcon__rmzeF"};